import {ValueObject} from '@s-ui/domain'

export default class PageNamePageValueObject extends ValueObject {}
/**
 * @param {Object} deps
 * @param {Object} deps.pageName
 */
